//AUTH
export const POST_NUMBA_LOGIN = "/auth/login";
export const POST_NUMBA_LOGOUT = "/auth/logout";
export const POST_NUMBA_SIGNUP = "/auth/signUp";
export const POST_NUMBA_FINDID = "/auth/findId";
export const POST_NUMBA_FINDPASSWORD = "/auth/updLostPwd";
export const POST_NUMBA_CHECKID = "/auth/checkId";
export const POST_NUMBA_SENDSMS = "/auth/sendSms";
export const POST_NUMBA_SELCHECKNO = "/auth/selCheckno";
export const POST_NUMBA_CODELIST = "/comm/codeList";
export const POST_NUMBA_SELUSERINFO = "/auth/selUserInfo";
export const POST_NUMBA_REFRESH = "/auth/refresh";
export const POST_NUMBA_REFRESHAFTERTIMEOUT = "/auth/refreshAfterTimeOut";
export const POST_NUMBA_CHKUSRFORW = "/auth/chkUsrforW";
export const POST_NUMBA_WITHDRAWUSER = "/auth/withdrawUser";

export const POST_NUMBA_CHECKBRNO = "/auth/findBrno";
export const POST_NUMBA_CHECKPHONE = "/auth/checkPhoneForSignUp";

// SELL
export const POST_NUMBA_INSSELLINDI = "/sell/insSellIndi";
export const POST_NUMBA_INSSELLCORP = "/sell/insSellCorp"; // 법인넘버 매도, 임대 ()
export const POST_NUMBA_INSSELLLIC = "/sell/insSellLic";
export const POST_NUMBA_SELLLIST = "/sell/sellList"; // 매도리스트 (주선면허, 개인, 법인)
export const POST_NUMBA_SELLDETAILLIST = "/sell/sellDetailList";
export const POST_NUMBA_SELLCODEDESCRIPTION = "/comm/selCodeDescription";

// BUY
export const POST_NUMBA_INSBUYINDI = "/buy/insBuyIndi";
export const POST_NUMBA_INSBUYCORP = "/buy/insBuyCorp"; // 법인넘버 매수, 임대 ()
export const POST_NUMBA_INSBUYLIC = "/buy/insBuyLic";
export const POST_NUMBA_BUYLIST = "/buy/buyList"; // 매수리스트 (주선면허, 개인, 법인)
export const POST_NUMBA_BUYDETAILLIST = "/buy/buyDetailList";

// MyNumberOne
export const POST_NUMBA_INSINTEREST = "/user/insInterest";
export const POST_NUMBA_DELINTEREST = "/user/delInterest";
export const POST_NUMBA_INTERESTLIST = "/user/interestList";
export const POST_NUMBA_USERMAINLIST = "/user/userMainList";
export const POST_NUMBA_USERCLIST = "/user/userCList";
export const POST_NUMBA_UPDCSELLCBUY = "/sale/updCSellCBuy";
export const POST_NUMBA_DELCSELLCBUY = "/sale/delCSellCBuy";
export const POST_NUMBA_USERSELLBUYLIST = "/user/userSellBuyList";
export const POST_NUMBA_UPDSELLBUY = "/sell/updSellBuy";
export const POST_NUMBA_USERCOMPLETEDLIST = "/user/userCompletedList";

export const POST_NUMBA_SELLBUYDETAILLIST = "/user/sellbuyDetailList";
export const POST_NUMBA_DELSELLBUY = "/sell/delSellBuy";
export const POST_NUMBA_UPDUSERINFO = "/auth/updUserInfo";
export const POST_NUMBA_CHKUSERFORW = "/auth/chkUsrforW";

export const POST_NUMBA_CHGPASSWD = "/auth/chgPasswd";

export const POST_NUMBA_MVALUELIST = "/comm/mValueList";
export const POST_NUMBA_KAKAO_SIGNUP = "/kakao/kakaoSignUp";
export const POST_NUMBA_KAKAO_LOGIN = "/kakao/kakaoLogin";

// file
// 암호화
export const POST_NUMBA_GETFILE = "/comm/getFile";
// 비암호화
export const POST_GETCOMMFILE = "/comm/getCommFile";
export const POST_DELFILE = "/comm/delFile";

// sale
export const POST_NUMBA_INSCBUY = "/sale/insCBuy";
export const POST_NUMBA_INSCSELL = "/sale/insCSell";
export const POST_NUMBA_SELLIC = "/sale/selLic";

// archive (자료실)
export const POST_NUMBA_ARCHIVELIST = "/supp/dataList";
export const POST_NUMBA_ARCHIVE_DETAIL = "/supp/selData";

// Customer Center
export const POST_NUMBA_INSQNA = "/supp/insQna";
export const POST_NUMBA_QNALIST = "/supp/qnaList";
export const POST_NUMBA_NOTICELIST = "/supp/noticeList";
export const POST_NUMBA_FAQLIST = "/supp/faqList";
export const POST_NUMBA_REVIEWLIST = "/supp/reviewList";
export const POST_NUMBA_SELREVIEW = "/supp/selReview";
export const POST_NUMBA_INSREVIEW = "/supp/insReview";
export const POST_NUMBA_INSREVIEW_C= "/supp/insReviewC";
export const POST_NUMBA_UPDREVIEW = "/supp/updReview";
export const POST_NUMBA_UPDREVIEW_C = "/supp/updReviewC";
export const POST_NUMBA_DELREVIEW = "/supp/delReview";

// alarm
export const POST_NUMBA_SELALARM = "/user/selAlarm";
export const POST_NUMBA_CHGALARM = "/user/chgAlarm";
export const POST_NUMBA_ALARMLIST = "/user/alarmList";
export const POST_NUMBA_UPDALARM = "/user/updAlarm";
export const POST_NUMBA_DELALARM = "/user/delAlarm";
// fcm
export const POST_INS_FCMTOKEN = "/fcm/insFcmToken";

export const POST_NUMBA_INSREF = "/comm/insRef";

export const POST_NUMBA_DELQNA = "/supp/delQna";
export const POST_NUMBA_UPDQNA = "/supp/updQna";
export const POST_NUMBA_DELQNAFILE = "/supp/delQnaFile";

// main
export const POST_NUMBA_MAIN_PRICE = "/comm/selMvalue";

// 파일 확인 메시지
export const POST_NUMBA_SEL_CODE_DESCRIPTION = "m/selCodeDescription";

// 신고증
export const POST_UPD_REPORT = "/user/updReport";
export const POST_SEL_REPORT = "/user/selReport";

export const POST_GETSIGNFILE = "/user/getSignFile";
export const POST_REPORT_LIST = "/user/reportList";
export const POST_GET_REPORTFILE = "/user/getReportFile";



// 운수종사자 일상 점검 (Daily Check) API

// 차량번호 조회 및 사용자 차량번호 저장
export const POST_DC_SEL_USER_VEH = "/dc/selUserVeh";
export const POST_DC_UPD_USER_VEH = "/dc/updUserVeh";

// 일상 점검 기준 항목 코드 리스트 조회
export const POST_DC_DAILY_CHECK_ITEM_CD_LIST = "/dc/dailyCheckItemCdList";

// 일상 점검 저장, 상세 조회 및 삭제
export const POST_DC_INS_DAILY_CHECK = "/dc/insDailyCheck";
export const POST_DC_SEL_DAILY_CHECK_DETAIL = "/dc/selDailyCheckDetail";
export const POST_DC_DEL_DAILY_CHECK = "/dc/delDailyCheck";

// 특정 달(Month)의 월별 점검 리스트 현황 조회
export const POST_DC_SEL_DC_LIST_BY_MONTH = "/dc/selDCListByMonth";

// 블록체인 데이터 조회
export const POST_DC_SEL_DC_BC_DATA = "/dc/selDCBCData";


// 블록체인 데이터 조회
export const POST_COMM_BANNER_LIST = "/comm/bannerList";
